import { baseApi } from '@/api/rtk/baseApi';
import { pageSize } from '@/shared/config/constants';

export const reportsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReports: builder.query({
      query: ({ userId, status, filters, search, page, toolId }) => ({
        url: '/get-reports/',
        method: 'POST',
        body: {
          user_id: userId,
          status,
          filters,
          search,
          page,
          toolId,
        },
      }),
      transformResponse: (response, _meta, arg) => {
        const list = response?.reports || [];
        const count = response?.summary?.[0]?.count ?? 0;
        const reports =
          arg.status === 'completed'
            ? list.filter((report) => report.report_fetched)
            : list;
        return {
          reports,
          totalCount: arg.status === 'completed' ? reports.length : count,
          totalPages: Math.ceil(count / pageSize),
        };
      },
      providesTags: ['Reports'],
      keepUnusedDataFor: 0,
    }),
    getReport: builder.query({
      query: ({ id, currentToolFields }) => ({
        url: '/get-report/',
        method: 'POST',
        body: {
          id,
          tool_fields: currentToolFields,
        },
      }),
      keepUnusedDataFor: 300,
      providesTags: (result, error, arg) => [
        { type: 'Reports', id: arg?.id || 'detail' },
      ],
    }),
    getPlaybackUrl: builder.query({
      query: (reportId) => ({
        url: '/get-signed-url',
        method: 'POST',
        body: { name: reportId, type: 'playback' },
      }),
      transformResponse: (response) => response?.url || '',
      keepUnusedDataFor: 40 * 60,
    }),
    getReportTemplates: builder.query({
      query: ({ toolId } = {}) => ({
        url: '/report-templates',
        method: 'POST',
        body: toolId ? { toolId } : {},
      }),
      providesTags: ['Templates'],
    }),
    updateReportStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: '/update-status/',
        method: 'POST',
        body: { status, id },
      }),
    }),
  }),
});

export const {
  useGetReportsQuery,
  useGetReportQuery,
  useGetPlaybackUrlQuery,
  useGetReportTemplatesQuery,
  useUpdateReportStatusMutation,
} = reportsApi;
